export default __webpack_public_path__ + "static/media/tog.f79f7d5d.png";